const config = {
    REACT_APP_TENANT: null,
    ...process.env,
    generalError:
      'There was a problem in connecting to the server. Please wait and the issue will be resolved shortly by the application team.',
  };
  
  export default config;
  